import React from "react";
import { AI_USAGE_GRANULARITY_OPTIONS } from "./aiUsageOverview.utils";

const AiUsageGranularityToggle = ({
  value = "day",
  options = ["day", "week", "month"],
  onChange,
  disabled = false,
}) => {
  const visibleOptions = AI_USAGE_GRANULARITY_OPTIONS.filter((option) =>
    options.includes(option.id)
  );

  if (visibleOptions.length <= 1) {
    return null;
  }

  return (
    <div
      className="flex shrink-0 rounded-lg border border-gray-200 bg-gray-50/80 p-1"
      role="group"
      aria-label="Trend granularity"
    >
      {visibleOptions.map((option) => (
        <button
          key={option.id}
          type="button"
          disabled={disabled}
          onClick={() => onChange?.(option.id)}
          className={`rounded-md px-3 py-1.5 text-xs font-medium transition-all whitespace-nowrap disabled:opacity-50 ${
            value === option.id
              ? "bg-white text-indigo-600 shadow-sm ring-1 ring-indigo-100"
              : "text-gray-600 hover:text-gray-900"
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default AiUsageGranularityToggle;
